import React from "react";
import ContentTable from "../components/ContentTable";

export default function Content() {
  return <ContentTable />;
}
